module.exports = __webpack_public_path__ + "img/1565699779.ab6afb00.jpg";